import { AttackPokemonData } from '../../types/attack';
import { POKEMON_ITEM_ID } from '../../types/item';
import type { ItemOption } from '../../types/item';
import { filterSelectableItemsForPokemon } from '../../lib/pokemon-config';
import PokemonItemSelect from '../PokemonItemSelect';

interface AttackPokemonItemInputProps {
  attackPokemon: AttackPokemonData;
  handleSelectItemForAttackPokemon: (id: string, itemId: POKEMON_ITEM_ID) => void;
  getOffenseItems: ItemOption[];
}

function AttackPokemonItemInput({
  attackPokemon,
  handleSelectItemForAttackPokemon,
  getOffenseItems,
}: AttackPokemonItemInputProps) {
  const pokemonId = attackPokemon.pokemon.id;
  const selectableItems = filterSelectableItemsForPokemon(pokemonId, getOffenseItems);
  const selectedItemId = attackPokemon.selectedItemId ?? attackPokemon.pokemon.selected_item_id;

  return (
    <PokemonItemSelect
      pokemon={attackPokemon.pokemon}
      items={selectableItems}
      value={selectedItemId}
      onChange={(itemId) => handleSelectItemForAttackPokemon(attackPokemon.id, itemId)}
      variant="sidebar"
      stopPropagation
    />
  );
}

export default AttackPokemonItemInput;
